import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { webSocket } from "rxjs/webSocket";
import { environment } from "src/environments/environment";
import { Observable, BehaviorSubject, Subject } from "rxjs";

export class Message {
  public carouselData?: CarouselCard[];
  constructor(
    public content: string,
    public sentBy: string,
    public timestamp: number,
    public buttons: any,
    public slotToElicit: string,
    public imageData: string,
    public showForm: boolean,
    public table?: Object,
    public imageDescription?: Object,
    public showImage?: boolean,
    public fileName?: string,
    carouselData?: CarouselCard[]
  ) {
    this.carouselData = carouselData;
  }
}

export interface CarouselCard {
  title: string;
  longMessage: string;
  offerStartDate: string;
  offerEndDate: string;
  offerId: string;
}

@Injectable({
  providedIn: "root",
})
export class ChatService {
  private typingIndicator = new Subject<any>();

  private showAttachmentIconSubject = new BehaviorSubject<boolean>(false);
  showAttachmentIcon$ = this.showAttachmentIconSubject.asObservable();

  _typingInterval: NodeJS.Timer;
  typingInProgress = false;

  arabic = /[\u0600-\u06FF\u0750-\u077F]/;

  conversation = new BehaviorSubject<Message[]>([]);
  wsConnected = new BehaviorSubject<boolean>(false);

  iconToggled = false;
  chatbots = environment.chatbots;
  sessionAttributes = {};
  agentConnected = false;
  private $pingInterval;

  public chatbotId = this.chatbots[0].Id;

  isNeedSendHello = true;

  constructor(private http: HttpClient) {}

  update(msg: Message) {
    console.log("msg=> ", msg);
    
    this.conversation.next([msg]);
  }

  typingIndicatorFn(): Observable<any> {
    return this.typingIndicator.asObservable();
  }

  callwebApi(body: any): Observable<any> {
    const apiUrl = `${environment.customDomainURL}web/message`;
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      withCredentials: true
    };
    console.log(
      "data from api",
      this.http.post<any>(apiUrl, body, httpOptions)
    );
    return this.http.post<any>(apiUrl, body, httpOptions);
  }

  getSignedUrlToUpload(body: any): Observable<any> {
    const apiUrl = `${environment.customDomainURL}live-agent/signed-attachment`;
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<any>(apiUrl, body, httpOptions);
  }

  getSignedUrlToDownload(fileName: string, fileType: string): Observable<any> {
    const apiUrl = `${environment.ceServerURL}live-agent/signed-attachment`;
    const body = {
      fileName,
      fileType,
      mode: "Get",
    };
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<any>(apiUrl, body, httpOptions);
  }
  

  getJwtToken(): Observable<any> {
    const apiUrl = `${environment.customDomainURL}web/init`;
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<any>(apiUrl, {sessionId: localStorage.getItem("sessionId")}, httpOptions);
  }

  uploadFile(url: string, file: File): Observable<any> {
    const headers = new HttpHeaders();
    console.log(file);
    headers.set("Content-Type", `${file.type}`);
    const params = new HttpParams();
    return this.http.put(url, file, { params, headers });
  }

  startTypingInterval() {
    if (this._typingInterval) clearInterval(this._typingInterval);
    this._typingInterval = setInterval(() => {
      if (this.typingInProgress) {
        this.http
          .post<any>(`${environment.customDomainURL}live-agent/web-events`, {
            sessionId: localStorage.getItem("sessionId"),
          })
          .subscribe(() => {
            this.typingInProgress = false;
          });
      }
    }, 1000);
  }

  converse(
    msg: any,
    sessionId: any,
    sessionState: any,
    userInfo: any,
    sessionDetails: any,
    seesionAtribb: any,
    slotToElicit: any,
    image: any,
    showMsg: any,
    clickedButton: any
  ): Promise<any> {
    this.typingIndicator.next(true);
    return new Promise((resolve, reject) => {
      // console.log('-->',msg);

      const userMsg = new Message(
          showMsg || msg,
        "user",
        new Date().getTime(),
        null,
        null,
        image,
        false
      );
      this.update(userMsg);

      const a: any = {
        message: msg.trim(),
        button: clickedButton,
        // chatbotId: this.chatbotId,
        sessionId,
        alias: environment.alias,
        ...(seesionAtribb?.selectedOfferId ? { sessionAttributes: seesionAtribb } : {})
        // chatbots: this.chatbots,
      };
      console.log(a);
      this.callwebApi(a).subscribe(
        (response: any) => {
          if (response.sessionState?.sessionAttributes?.botId) {
            this.chatbotId = response.sessionState.sessionAttributes.botId;
          }
          resolve(response);
        },
        (err) => {
          console.log("err", err);
          resolve(err);
        }
      );
    });
  }

  connectToServerByWebSocket() {
    this.getJwtToken().subscribe(
        (response: any) => {
          const token = response.token;
          let ws = new WebSocket(`${environment.webSocketURL}?X-TLCE-Auth-token=${token}`);
          ws.onopen = (event) => {
            console.log("WS connection opened successfully.", new Date());
            this.wsConnected.next(true);
            this.$pingInterval = setInterval(() => {
              if (ws)
                ws.send(JSON.stringify({action: 'heartbeat', message: 'ping'}))
            },300000);
          };
          ws.onclose = (event) => {
            console.log("WS connection has been closed with code", event?.code, new Date());
            clearInterval(this.$pingInterval);
            ws = null;
            setTimeout(() => {
              this.connectToServerByWebSocket();
            }, 1000);
          };

          ws.onerror = (event) => {
            console.log("WS error event", event, new Date());
          }

          ws.onmessage = (event) => {
            if (event.data === "pong") return;
            
            console.log("Message from server ", JSON.parse(event.data));
            const messageData = JSON.parse(event.data);
            
            if (messageData.caseStatus === "Opened") {
              this.showAttachmentIconSubject.next(true);
            }

            if (messageData.caseStatus === "Closed") {
              this.showAttachmentIconSubject.next(false);
            }

            if (messageData.message.indexOf("attachment:") !== -1) {
              const fileName = messageData.message.split(":")[1];
              const fileType = messageData.message.split(":")[2];
              const obj = {
                fileName: fileName.split("/")[1],
                fileType,
                mode: "Get",
              };
              this.getSignedUrlToUpload(obj).subscribe((res) => {
                if (res && res.url) {
                  let imageData = null;
                  if (fileType.indexOf("image/") !== -1) {
                    imageData = res.url;
                  } else {
                    messageData.message = this.replaceLinksInMessage(res.url, fileName);
                  }
                  const userMessage1 = new Message(
                      messageData.message,
                      "bot",
                      new Date().getTime(),
                      null,
                      null,
                      imageData,
                      false,
                      null,
                      null,
                      false,
                      messageData.message
                  );
                  this.update(userMessage1);
                }
              });
            } else if (messageData.message.includes("<image>")) {
              const userMessage = new Message(
                  "image",
                  "bot",
                  new Date().getTime(),
                  messageData.buttons,
                  null,
                  null,
                  false,
                  null,
                  messageData.message.replace(/<image>/gi,"")
              );
              this.update(userMessage);
            } else {
              let messageContent = messageData.message ? 
                  this.replaceLinksInMessage(messageData.message.replace(/\n/g, "<br/>")) : "";
          
              if (messageData.attachments && messageData.attachments.length > 0) {
                   messageData.attachments.forEach((attachment) => {
                    messageContent += `<br/><img src="${attachment.url}" alt="${attachment.title}" />`;
                  });
              }
          
              const userMessage = new Message(
                  messageContent,
                  "bot",
                  new Date().getTime(),
                  messageData.buttons,
                  null,
                  null,
                  false,
                  messageData.attachments?.[0]?.title || null,
                  messageData.message,
                  false,
                  "",
                  messageData.carouselData 
              );
              this.update(userMessage);
            }
          };
        });
  }

  postUserRating(rating, feedback): Observable<any> {
    const body = {
      botId: this.chatbotId,
      channel: "web",
      rating: +rating,
      userId: localStorage.getItem("sessionId"),
      requestType: "create",
      feedback: feedback || "",
    };
    const apiUrl = `${environment.customDomainURL}chatbot/save-rating`;
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<any>(apiUrl, body, httpOptions);
  }

  isArabic(message): boolean {
    return this.arabic.test(message);
  }

  replaceLinksInMessage(srcMessage, title?): string {
    let values = srcMessage.split(" ");
    if (!title) {
      title = this.isArabic(srcMessage) ? "رابط" : "link";
    }
    values.forEach((ele, index) => {
      if (ele.includes("http")) {
        values[index] = `<a href="${ele}" target="_blank"> ${title} </a>`;
      }
    });
    values = values.join(" ");
    return values;
  }
}
